import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { submitMonthDeclaration } from '@/domain/project-venue-month-declaration/actions/submit-month-declaration.action';
import { VenueCo2MonthValues } from '@/domain/project-venue-month-declaration/entities/project-venue-month-declaration';
import { selectProjectVenuesMonthDeclarationByMonth } from '@/domain/project-venue-month-declaration/project-venue-month-declarations.selectors';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { QuizFormSectionTitle } from '@/ui/pages/app/components/quiz-panel/co2/components/QuizFormSectionTitle';
import { DigitalForm } from '@/ui/pages/app/project/venue/dates/components/co2-month-quiz/forms/DigitalForm.tsx';

import { CateringBeverageForm } from './forms/CateringBeverageForm';
import { CateringMealForm } from './forms/CateringMealForm';
import { EnergyForm } from './forms/EnergyForm';
import { NonRecyclableWasteForm } from './forms/NonRecyclableWasteForm';
import { RecyclableWasteForm } from './forms/RecyclableWasteForm';
import { WaterForm } from './forms/WaterForm';

const EMPTY_CO2_MONTH_VALUES: VenueCo2MonthValues = {
  cateringMeal: [],
  cateringBeverage: [],
  energy: [],
  water: {
    sector: 'SITE',
    waterConsumptionVolume: 0,
  },
  wasteRecyclable: [],
  wasteNonRecyclable: [],
  digital: {
    sector: 'PUBLIC',
    dataUsage: 0,
    videoViews: 0,
  },
};

export function Co2MonthQuiz({ month }: { month: string }) {
  const dispatch = useAppDispatch();

  const project = useAppSelector(selectCurrentProjectVenue);

  const monthDeclaration = useAppSelector(
    selectProjectVenuesMonthDeclarationByMonth(month),
  );

  let co2MonthValues;
  if (monthDeclaration?.co2) {
    co2MonthValues = monthDeclaration.co2;
  } else {
    co2MonthValues = EMPTY_CO2_MONTH_VALUES;
  }

  const onEdit = (co2Values: VenueCo2MonthValues) => {
    const newMonthDeclaration = { ...monthDeclaration, co2: co2Values };
    dispatch(
      submitMonthDeclaration({
        projectId: project?.id || -1,
        month,
        monthDeclaration: newMonthDeclaration,
      }),
    );
  };

  return (
    <>
      <QuizFormSectionTitle title={translate('Projects.public')} />
      <CateringMealForm onEdit={onEdit} co2MonthValues={co2MonthValues} />
      <CateringBeverageForm onEdit={onEdit} co2MonthValues={co2MonthValues} />
      <QuizFormSectionTitle title={translate('Projects.site')} />
      <EnergyForm onEdit={onEdit} co2MonthValues={co2MonthValues} />
      <WaterForm onEdit={onEdit} co2MonthValues={co2MonthValues} />
      <RecyclableWasteForm onEdit={onEdit} co2MonthValues={co2MonthValues} />
      <NonRecyclableWasteForm onEdit={onEdit} co2MonthValues={co2MonthValues} />
      <QuizFormSectionTitle title={translate('Projects.numeric')} />
      <DigitalForm onEdit={onEdit} co2MonthValues={co2MonthValues} />
    </>
  );
}
